import React from "react";
import { Input } from "../screens/update-property/style";
import { FieldMetaProps } from "formik";
import { useTranslation } from "react-i18next";

interface CoordinateInputProps {
  value: string;
  placeholder: string;
  meta?: {
    touched: boolean;
    error?: string;
  };
  name: string;
  setFieldValue: (field: string, value: any) => void;
  onChange: (value: string) => void
}

const CoordinateInput: React.FC<CoordinateInputProps> = ({
  value,
  placeholder,
  meta,
  name,
  setFieldValue,
  onChange
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = event.target.value
      .toUpperCase()
      .replace(/[^0-9NSEW]/g, "");
    const directionMatch = rawValue.match(/[NSEW]$/);
    const direction = directionMatch ? directionMatch[0] : "";
    const digits = direction ? rawValue.slice(0, -1) : rawValue;

    const seconds = digits.slice(-3);
    const minutes = digits.slice(-5, -3);
    const degrees = digits.slice(0, -5);

    let formatted = "";
    if (degrees) formatted += `${degrees}°`;
    if (minutes) formatted += `${minutes}'`;
    if (seconds) {
      if (seconds.length > 2) {
        const intPart = seconds.slice(0, 2);
        const decimal = seconds.slice(2);
        formatted += `${intPart}.${decimal}"`;
      } else {
        formatted += `${seconds}"`;
      }
    }
    if (direction) formatted += ` ${direction}`;

    setFieldValue(name, formatted.trim()); // <-- Atualiza o valor no Formik
    onChange(formatted.trim())
  };

  const { t } = useTranslation();

  return (
    <div>
      <Input
        type="text"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: "5px",
          border: `1px solid ${meta?.touched && meta.error ? "red" : "#ccc"}`,
        }}
      />
      {meta?.touched && meta?.error && (
        <div
          className="error"
          style={{
            color: "red",
            fontSize: "14px",
            marginBottom: "10px",
          }}
        >
          {t(meta?.error)}
        </div>
      )}
    </div>
  );
};

export default CoordinateInput;
